import { ConfigNavbarWrapper as UnifiedConfigNavbarWrapper } from "@unified-dashboard/src/components/layout/config-navbar";
import GetAuthContext from "../../context/AuthContext";
import GetMixpanelContext from "../../context/MixpanelContext";
import { authService } from "../../../services/apis";
import { Post } from "../../services/Fetch";
import { useCallback } from "react";

export default function ConfigNavbarWrapper() {
  const { userState, logout } = GetAuthContext();
  const { resetIdentity } = GetMixpanelContext();

  const getToken = useCallback(
    () => authService.getToken() || "",
  []);

  return (
    <UnifiedConfigNavbarWrapper
      variant="platform"
      userState={userState}
      logout={logout}
      resetIdentity={() => resetIdentity()}
      getToken={getToken}
      postRequest={Post}
    />
  );
}
